import React, { Component } from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import { FormattedMessage } from 'react-intl';
import { string, array } from 'prop-types';
import DashboardSettingsSectionItemNew from './DashboardSettingsSectionItemNew';

const SortableList = SortableContainer(({ items = [], section, onItemChange }) => (
  <ul className="dashboard-settings-items">
    {items.map((item, i) => (
      <DashboardSettingsSectionItemNew
        index={i}
        collection={section}
        key={item.id}
        section={section}
        PFxtv
        onChange={onItemChange}
        {...item}
      />
    ))}
  </ul>
));

class DashboardSettingsSection extends Component {
  static propTypes = {
    title: string.isRequired,
    items: array.isRequired,
  };

  onSortEnd = ({ oldIndex, newIndex, collection }) => {
    this.props.onSort(oldIndex, newIndex, collection);
  };

  render() {
    const { title, items, onItemChange, onSort } = this.props;

    return (
      <section className="dashboard-settings-section">
        {/* <span className="dashboard-settings-section-title">
          <FormattedMessage
            id={`widgets.dashboard-settings.section.${title}`}
            defaultMessage={title}
          />
        </span> */}

        <SortableList
          section={title}
          items={items}
          onSortEnd={this.onSortEnd}
          onItemChange={onItemChange}
          helperClass="dashboard-settings-item--dragging"
          useDragHandle
        />
      </section>
    );
  }
}

export default DashboardSettingsSection;
